import { Component, OnInit, ViewChild } from '@angular/core';
import {MatIconModule } from '@angular/material/icon';
import { LicensesServiceService } from '../services/licenses-service.service';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import { FormsModule, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { PixModalComponent } from "../../../pix-modal/pix-modal.component";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertComponent } from '../../../alert/alert.component';
import { LoadingModalComponent } from '../../../loading-modal/loading-modal.component';
import { ClientPipe, ClientPipeStatus } from './pipes/client.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-licencas',
  standalone: true,
  imports: [MatIconModule, CommonModule, FormsModule, ReactiveFormsModule, PixModalComponent, MatProgressSpinnerModule, AlertComponent, LoadingModalComponent, ClientPipe, ClientPipeStatus, NgxPaginationModule],  // Importando o Material Icon Module
  templateUrl: './licencas.component.html',
  styleUrls: ['./licencas.component.scss'],
  providers: [LicensesServiceService]
})
export class LicencasComponent  implements OnInit {

  //Variaveis de Clientes
  //public currentClients: Array<any> = [];
  public listClients: Array<any> = [];
  public listRevendedores: Array<any> = [];
  public creditsUser?: string ;
  public clientesAtivos: number = 0;
  public clientesInativos: number = 0;
  public canaisAtivos: number = 0;
  public canaisInativos: number = 0;


  //Variaveis de filtro e paginacao
  public filterName: string = "";
  public filterStatus: "TODOS" | "ATIVO" | "INATIVO" = "TODOS";

  public objectPage: any = {
    currentPage: 1,
    itemsPerPage: 5,
    totalPages: 0
  }

  //Variaveis de manipular selecao de cliente
  public selectedClients: Array<any> = [];
  public isCheckedClient: boolean = false;
  public clientsSelected: boolean = false;


  //Variaveis para creditos
  public formCredits: FormGroup;
  public activeModalCredits: boolean = false;
  @ViewChild(PixModalComponent) pixModal!: PixModalComponent;
  public isLoadingAddCredits: boolean = false;

  //Variaveis para renovacao do cliente
  public activeModalRenew: boolean = false;
  public formRenovarCliente: FormGroup;
  public selectedClientRenew: any;
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingModal!: LoadingModalComponent;

  constructor(private licensesService: LicensesServiceService, private fb: FormBuilder) {
    this.formCredits = this.fb.group({
      creditos: ['', [Validators.required, Validators.min(1)]],
    })

    this.formRenovarCliente = this.fb.group({
      idcliente: ['', [Validators.required]],
      renovacao: ['', [Validators.required]]
    });
   }

  ngOnInit() {
    this.listLicensesClientes();
  }

  // ngDoCheck() {
  //   if (this.filterName !== "") {
  //     this.listLicensesClientes();
  //   }
  // }

  //Funcao de controle de acesso
  public returnLevel(): number {
    return Number(atob(localStorage.getItem('uL') ?? ''));
  }

  public listLicensesClientes(){
    this.licensesService.getClientsLicenses().subscribe(async (response: any) => {
      this.listClients = response.retorno;
      this.creditsUser = response.credits;
      this.clientesAtivos = 0;
      this.canaisAtivos = 0;
      this.clientesInativos = 0;
      this.canaisInativos = 0;
      this.objectPage.totalPages = Math.ceil(this.listClients.length / this.objectPage.itemsPerPage);


      this.listClients.forEach((element: any)=> {
        if(element.status === 'ATIVO') {
          this.clientesAtivos ++;
          this.canaisAtivos += element.canais;
        }else {
          this.clientesInativos++;
          this.canaisInativos += element.canais;
        }
      })

      if(this.returnLevel() === 3) {
        this.listClients.forEach((element: any)=> {
          this.listRevendedores.push(element.revendedor);
        })

        this.listRevendedores = [...new Set(this.listRevendedores)];
      }
    }, (error: any) => {
      console.error(error);
    });
  }

  //funcoes para a listagem das licencas dos clientes
  public formatData(data: Date): any{
    return moment(data).format('DD/MM/YYYY')
  }

  public alterRen(client: any){
    this.loadingModal.activeLoading();
    const request$ = client.billingCreditsRecorrency
      ? this.licensesService.sendRequestInactivateRenewAuto(client.idcliente)
      : this.licensesService.sendRequestActivateRenewAuto(client.idcliente);

    request$
      .pipe(finalize(() => this.loadingModal.inactiveLoading()))
      .subscribe({
        next: () => {
          this.listLicensesClientes();
          this.alertComponent.showAlert(
            client.billingCreditsRecorrency
              ? 'Renovacao automatica por creditos desativada para este cliente!'
              : 'Renovacao automatica por creditos ativada para este cliente!',
            client.billingCreditsRecorrency ? 'warning' : 'success'
          );
        },
        error: () => {
          this.alertComponent.showAlert(
            'Erro ao atualizar renovacao automatica.',
            'error'
          );
        },
      });
  }

  public teste(item: number){
    
  }

  //Funcoes para renovar os clientes
  public onCheckBoxSelectedClient(event: Event, idClient: number, emailClient: string, quantidadeCanais: number){
    const isChecked = (event.target as HTMLInputElement).checked;

    if((event.target as HTMLInputElement).checked === true) {
      this.selectedClients.push({
        idClient: idClient, 
        emailClient: emailClient, 
        quantidadeCanais: quantidadeCanais
      });
       if(this.selectedClients.length > 0) {
        this.clientsSelected = true;
      }else {
        this.clientsSelected = false;
      }
      
    }else {
      
      this.selectedClients = this.selectedClients.filter((element: any) => element.idClient!== idClient);
      if(this.selectedClients.length <= 0) {
        this.clientsSelected = false;
        console.log(this.selectedClients)
      }else {
        this.clientsSelected = true;
      }
      
    }
  }

  public sendPedidoRenewClients(){
    this.loadingModal.activeLoading();
    this.licensesService.sendPedidoRenewClientes(this.selectedClients).subscribe((response: any) => {
      this.loadingModal.inactiveLoading();
      this.pixModal.showModal(response.qrcode, response.codepix);
      this.listLicensesClientes();
    }, (error: any) => {
      console.log(' Error');
    });
  }


  //FUNCOES PARA ADICIONAR CREDITOS
  public abrirModalCreditos(){
    this.activeModalCredits = true;
  }

  public fecharModalCreditos(){
    this.activeModalCredits = false;
    this.listLicensesClientes();
  }
  public adicionarCreditos(){
    console.log(this.formCredits.value);
    this.loadingModal.activeLoading()
    this.licensesService.setCredits(this.formCredits.value).subscribe((response: any) => {
      
      this.loadingModal.inactiveLoading();
      this.pixModal.showModal(response.qrcode, response.codepix);
      this.listLicensesClientes();
      this.fecharModalCreditos();
      this.isLoadingAddCredits = false;
    }, (error: any) => {
      console.error(error);
      this.alertComponent.showAlert('Erro ao gerar codigo pix', 'error');
    });
    this.formCredits.reset();
  }



  //Funcoes de paginacao e filtros
  public alterItemsPerPage(event: Event){
    let valItemPage = event.target as HTMLSelectElement;
    this.objectPage.itemsPerPage = valItemPage.value;
    //this.listLicensesClientes();
  }


  public previousPage(){
    if (this.objectPage.currentPage > 1) {
      this.objectPage.currentPage = this.objectPage.currentPage - 1;
    }
    //this.listLicensesClientes();
  }

  public nextPage(){
    this.objectPage.currentPage += 1;

    // let offset = (this.objectPage.currentPage - 1) * this.objectPage.itemsPerPage;

    // this.listLicensesClientes();
  }

  public isFirstPage() {
    if (this.objectPage.currentPage <= 1) return true;

    return false;
  }

  public isLastPage() {
    if (this.objectPage.currentPage >= this.objectPage.totalPages) return true;

    return false;
  }

  public async sliceClients(dataClients: any) {
    //Criar o offset =  paginal atual -1 multiplicado pelo total de itens por pagina

    if (this.objectPage.currentPage === 1) {

      let offset = (this.objectPage.currentPage - 1) * this.objectPage.itemsPerPage;

      return dataClients.slice(0, this.objectPage.itemsPerPage);
    } else {

      let offset = (this.objectPage.currentPage - 1) * this.objectPage.itemsPerPage;

      return dataClients.slice(offset, offset + this.objectPage.itemsPerPage);
    }

  }

  //Funcoes para renovar os clientes
  public abrirModalRenovarCliente(client: any){
    this.activeModalRenew = true;
    this.formRenovarCliente.patchValue({
      idcliente: client.idcliente
    })
  }

  public fecharModalRenovarCliente(){
    this.activeModalRenew = false;
    this.formRenovarCliente.reset();
    this.listLicensesClientes();
  }

  public sendPedidoRenovarCliente(){
    this.licensesService.sendPedidoRenovarClientesAdmin(this.formRenovarCliente.value).subscribe((response: any) => {
      this.alertComponent.showAlert('Cliente atualizado com sucesso', 'success');
      this.fecharModalRenovarCliente();
    }, (error: any) => {
      console.log(' Error');
      this.alertComponent.showAlert('Erro ao atualizar o cliente', 'error');
    });
  }

  sendPedidoRenovarClienteCredito(){
    this.licensesService.sendPeidoRenovarClientAdminCredits({idClient: this.formRenovarCliente.value.idcliente}).subscribe((response: any) => {
      this.alertComponent.showAlert('Cliente atualizado com sucesso', 'success');
      this.fecharModalRenovarCliente();
    }, (error: any) => {
      console.log(' Error');
      this.alertComponent.showAlert('Erro ao atualizar o cliente', 'error');
    });
  }

  public sendPedidoBloquearCliente(idClient: number){
    this.licensesService.sendPedidoBloquearClientesAdmin(idClient).subscribe((response: any) => {
      this.alertComponent.showAlert('Cliente bloqueado com sucesso', 'success');
      this.listLicensesClientes();
    }, (error: any) => {
      console.log(' Error');
      this.alertComponent.showAlert('Erro ao bloquear o cliente', 'error');
    });
  }

  public renovarClientePix(client: any){
    this.loadingModal.activeLoading();
    this.licensesService.sendPedidoRenovarCliente(client).subscribe((response: any) => {
      this.loadingModal.inactiveLoading();
      this.pixModal.showModal(response.qrcode, response.codepix);
    },(error: any) => {
      console.log(error);
      this.alertComponent.showAlert('Erro ao tentar renovar cliente', 'error');
    });
  }

}
